import React, {
  ReactNode,
} from 'react';
import ToolTip from 'core/components/Tooltip';
import MuiIconButton, {
  IconButtonProps,
} from '@mui/material/IconButton';
import {
  isEmptyString,
} from '@populateui/utils';

type Props = IconButtonProps & {
  tooltip?: ReactNode;
  hideTooltip?: boolean;
  children: ReactNode;
};

export default function IconButton({
  tooltip,
  hideTooltip,
  children,
  disableFocusRipple = false,
  ...props
}: Props) {
  return (
    <ToolTip title={tooltip} hide={hideTooltip || isEmptyString(tooltip)}>
      <span>
        <MuiIconButton
          {...props}
          disableFocusRipple={disableFocusRipple}
        >
          {children}
        </MuiIconButton>
      </span>
    </ToolTip>
  );
}
